import React from "react"

import { useStaticQuery, graphql } from "gatsby"

import Link from "./common/Link"

import "./footer.scss"

const Footer = () => {
  const [isMounted, setIsMounted] = React.useState(false)

  const data = useStaticQuery(graphql`
    {
      saleor {
        shop {
          name
        }
        pages(first: 100) {
          edges {
            node {
              id
              slug
              title
              isPublished
            }
          }
        }
      }
    }
  `)

  const pages = data.saleor.pages.edges.filter((page) => page.node.isPublished)

  React.useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) {
    return <div></div>
  }

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__brand">
          <Link to="/">{data.saleor.shop.name}</Link>
        </div>
        <div className="footer__links">
          <div>
            <Link to="/products/">Products</Link>
          </div>
          {pages.map(({ node }) => (
            <div key={node.slug}>
              <Link to={`/${node.slug}/`}>{node.title}</Link>
            </div>
          ))}
          <div>
            <Link to="/contact-us/">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
